import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EmpresasModel } from 'src/app/pages/configuracion/maestros/empresas/models/empresas-model';
import { IRecuperarEmpresasService } from './ports/i-recuperar-empresas-service';
import { EndpointService } from 'src/app/shared/services/endpoint.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { map } from 'rxjs/operators';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { FiltroBasico } from 'src/app/shared/models/filtros';

@Injectable({
  providedIn: 'root'
})
export class RecuperaEmpresasApiService implements IRecuperarEmpresasService{

  private readonly URL_GET_EMPRESAS: string = this.endpointService.UrlGetEmpresas;
  private readonly URL_GUARDA_EMPRESA: string = this.endpointService.UrlGuardaEmpresa;
  private readonly URL_DELETE_EMPRESA: string = this.endpointService.UrlDeleteEmpresa;

  empresas: any;
  refreshEmpresas: boolean;
  countEmpresas: number = 0

  constructor(private endpointService: EndpointService,
              private client: HttpClient,
              private loginService: LoginService,
              private conversionDatosApiService: ConversionDatosApiService) { }


  getEmpresas(filtros: FiltroBasico[], pageNumber:number, orden: OrdenColumna = {campoOrden:'', orden:''}): Observable<EmpresasModel[]> {

    let pageSizeParam:number = pageNumber==0 ? 0 : 50;
    let pageNumberParam:number = pageNumber==0 ? 0 : pageNumber;
    let filtroBuscar = filtros.find(x=>x.text=='Buscar')?.value;

    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      }),
      params: new HttpParams()
      .set('pageNumber', pageNumberParam)
      .set('pageSize', pageSizeParam)
      .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
    }

    if (orden.campoOrden) {
      httpOptions.params = httpOptions.params.set(`orden[${orden.campoOrden.toUpperCase()}]`, orden.orden);
    }

    return this.client.get(this.URL_GET_EMPRESAS, httpOptions).pipe(
      map((response: any) =>{
        if (response) {
          this.empresas = this.conversionDatosApiService.mapEmpresasEntrada(response)
          this.refreshEmpresas = false;
          return this.empresas;
        }
        else throw new Error(response);
      })
    );
  }


  guardaEmpresa(data:any): Observable<void>{
    data = this.conversionDatosApiService.mapEmpresasSalida(data);

    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.post<void>(this.URL_GUARDA_EMPRESA, data, options)
  }

  deleteEmpresa(data:any): Observable<void>{
    data = this.conversionDatosApiService.mapEmpresasSalida(data);
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    let url = this.URL_DELETE_EMPRESA.replace('{codigoEmpresa}', data.CodigoEmpresa);
    return this.client.delete<void>(url, options);
  }
}
